import React from 'react';
import { DollarSign, Clock, Construction } from 'lucide-react';

const ChargesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-blue-100 rounded-full p-4">
            <Construction className="w-16 h-16 text-blue-600" />
          </div>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Coming Soon</h1>
        <div className="flex justify-center mb-4">
          <DollarSign className="w-12 h-12 text-gray-400" />
        </div>
        <p className="text-xl text-gray-600 mb-2">Annual Charges</p>
        <p className="text-gray-500 mb-6">
          This feature is currently under development. You'll be able to view and manage your annual charges here soon.
        </p>
        <div className="flex items-center justify-center gap-2 text-sm text-gray-400">
          <Clock className="w-4 h-4" />
          <span>We're working hard to bring you this feature</span>
        </div>
      </div>
    </div>
  );
};

export default ChargesPage;
